<template>
  <div class="mi-page">
    <BackButton />
    <div class="mi-head">
      <h2>My Invoices</h2>
      <p class="mi-sub">Invoices issued to your company across all your Flockr suppliers.</p>
    </div>
    <div v-if="loading" class="mi-loading"><i class="mdi mdi-loading mdi-spin"></i> Loading…</div>
    <div v-else-if="!invoices.length" class="mi-empty">
      <i class="mdi mdi-file-document-outline"></i>
      <p>No invoices yet. Once your supplier issues one, it'll appear here.</p>
    </div>
    <div v-else class="table-responsive"><table class="mi-table">
      <thead><tr><th>Invoice</th><th>Supplier</th><th>Issued</th><th>Due</th><th class="num">Total</th><th class="num">Balance</th><th>Status</th><th></th></tr></thead>
      <tbody>
        <tr v-for="inv in invoices" :key="inv.id" :class="{overdue: inv.status==='overdue'}">
          <td><strong>{{ inv.invoice_number }}</strong></td>
          <td>{{ inv.farm_name || inv.seller_name }}</td>
          <td>{{ inv.issue_date }}</td>
          <td>{{ inv.due_date }}</td>
          <td class="num">{{ fmt(inv.total_kes) }}</td>
          <td class="num bal" :class="{warn:Number(inv.balance_kes)>0}">{{ fmt(inv.balance_kes) }}</td>
          <td><span class="mi-status" :class="'st-'+inv.status">{{ statusLabel(inv.status) }}</span></td>
          <td><a :href="'#/invoice/'+inv.public_token" class="mi-link">View / Pay</a></td>
        </tr>
      </tbody>
    </table></div>
  </div>
</template>

<script>
import { executeJson, flocker } from "@/api";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "MyInvoicesPage",
  components: { BackButton },
  data(){return{ loading:true, invoices:[] }},
  mounted(){ this.load(); },
  methods:{
    async load(){
      this.loading = true;
      try {
        const r = await executeJson({ function: "getMyCorporateInvoices", userId: sessionStorage.getItem("userId") }, flocker);
        if (r.data && r.data.success) this.invoices = r.data.data.invoices || [];
      } catch (e){ /* silent */ }
      this.loading = false;
    },
    fmt(v){ return Number(v || 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}); },
    statusLabel(s){ return ({ sent:"Sent", viewed:"Viewed", partially_paid:"Partial", paid:"Paid", overdue:"Overdue", draft:"Draft" })[s] || s; },
  }
};
</script>

<style scoped>
.mi-page{max-width:1100px;margin:0 auto;padding:24px 20px 80px;color:#1A1A1A}
html[data-theme="dark"] .mi-page{color:#F5F1E8}
.mi-head h2{margin:0 0 4px;font-size:24px;letter-spacing:-0.3px}
.mi-sub{margin:0 0 18px;color:#6B6356;font-size:13px}
html[data-theme="dark"] .mi-sub{color:#A8A095}
.mi-loading,.mi-empty{text-align:center;padding:60px;color:#8A827A}
.mi-empty i{font-size:48px;color:#BFA164;opacity:.5}
.mi-table{width:100%;border-collapse:collapse;font-size:13px;background:#FFFFFF;border-radius:10px;overflow:hidden}
html[data-theme="dark"] .mi-table{background:#1C1A16}
.mi-table th{background:#F5F1E8;color:#6B6356;padding:10px 14px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.5px}
html[data-theme="dark"] .mi-table th{background:#252119;color:#A8A095}
.mi-table td{padding:10px 14px;border-top:1px solid #F0EBE4}
html[data-theme="dark"] .mi-table td{border-color:#2A2620}
.mi-table th.num,.mi-table td.num{text-align:right}
.mi-table tr.overdue{background:#FEF6F4}
.mi-table td.bal.warn{color:#B71C1C;font-weight:600}
.mi-status{font-size:10px;font-weight:700;padding:2px 8px;border-radius:10px;text-transform:uppercase;letter-spacing:.5px}
.mi-status.st-sent{background:#E8E0D0;color:#5C4533}
.mi-status.st-viewed{background:#D6E5F0;color:#1F4F7A}
.mi-status.st-partially_paid{background:#FFE0B2;color:#8B5A2B}
.mi-status.st-paid{background:#C8E6C9;color:#1F6B1F}
.mi-status.st-overdue{background:#FFCDD2;color:#B71C1C}
.mi-link{color:#BFA164;text-decoration:none;font-weight:600}
.mi-link:hover{color:#A8854F}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .mi-page { padding: 14px 12px calc(80px + env(safe-area-inset-bottom, 0px)) !important; }
  .mi-head h2 { font-size: 20px; }
  .mi-sub { font-size: 12px; }
  .mi-table { font-size: 11px; }
  .mi-table th, .mi-table td { padding: 7px 9px; }
  .mi-status { font-size: 9px; padding: 1px 6px; }
}
</style>
